'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _or2 = require('./_internal/_or');

var _or3 = _interopRequireDefault(_or2);

var _INT_TWO = require('./_constants/INT_TWO');

var _INT_TWO2 = _interopRequireDefault(_INT_TWO);

var _call = require('./call');

var _call2 = _interopRequireDefault(_call);

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

var _define = require('./define');

var _define2 = _interopRequireDefault(_define);

var _getProp = require('./getProp');

var _getProp2 = _interopRequireDefault(_getProp);

var _has = require('./has');

var _has2 = _interopRequireDefault(_has);

var _reverse = require('./reverse');

var _reverse2 = _interopRequireDefault(_reverse);

var _spread = require('./spread');

var _spread2 = _interopRequireDefault(_spread);

var _ternaryWith = require('./ternaryWith');

var _ternaryWith2 = _interopRequireDefault(_ternaryWith);

var _toString = require('./toString');

var _toString2 = _interopRequireDefault(_toString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var callToString = (0, _call2.default)(_toString2.default); /**
                                                             * Cache return contents of functions
                                                             *
                                                             * @module memoize
                                                             * @func
                                                             * @since 1.9.0
                                                             * @param {function} fn - Function to templatize
                                                             * @param [function] template - Function to determine cache key
                                                             * @return {function}
                                                             */

var defaultTemplate = (0, _compose2.default)(callToString, _spread2.default);
var getPropR = (0, _reverse2.default)(_getProp2.default, _INT_TWO2.default);

var memoize = function memoize(fn, template) {
    var tmpl = (0, _or3.default)(template, defaultTemplate);
    var cache = {};
    var fromCache = getPropR(cache);
    var cacheHas = (0, _has2.default)(cache);
    var callFn = (0, _call2.default)(fn);
    var caller = (0, _define2.default)(function (args, val) {
        cache[val] = callFn(args);
        return cache[val];
    });
    var internal = function internal(args) {
        return (0, _ternaryWith2.default)(caller(args), fromCache, cacheHas, tmpl(args));
    };
    return (0, _compose2.default)(internal, _spread2.default);
};

exports.default = memoize;